"use client";
import { useEffect } from "react";
import "../../components/RepaymentWidget/RepaymentWidget.css";

export default function LoanOptionsWidget() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const partnerId = params.get("partnerId") || "2971";

    localStorage.setItem("externalPartnerId", partnerId);
    localStorage.setItem("sourceUrl", "https://keychoicelending.com.au/");
    localStorage.setItem("source", "Key Choice Lending");
    localStorage.setItem("targetSystem", "SKYNET");
    localStorage.setItem("countryCode", "AU");

    const css = document.createElement("link");
    css.href =
      "https://loanoptions-widget.s3.ap-southeast-2.amazonaws.com/v2/main/css/main.css";
    css.rel = "stylesheet";
    document.head.appendChild(css);

    const script = document.createElement("script");
    script.src =
      "https://loanoptions-widget.s3.ap-southeast-2.amazonaws.com/v2/main/js/main.js";
    script.async = true;

    script.onload = () => {
      console.log("LoanOptions widget script loaded");

      const expectedIds = [
        "loan-type-loan-box-PROPERTY_REDIRECT",
        "loan-type-loan-box-COMMERCIAL_PROPERTY",
        "loan-type-loan-box-SMSF_REDIRECT",
        "loan-type-loan-box-REVERSE_MORTGAGE_REDIRECT",
        "loan-type-loan-box-CAR_LOAN",
        "loan-type-loan-box-EQUIPMENT_LOAN",
        "loan-type-loan-box-PERSONAL_LOAN",
        "loan-type-loan-box-BUSINESS_LOAN",
      ];

      const waitForAllCards = () => {
        const loaded = expectedIds.every((id) => document.getElementById(id));
        if (loaded) {
          reorderCards();
        } else {
          setTimeout(waitForAllCards, 100);
        }
      };

      const reorderCards = () => {
        const container = document.querySelector(
          "#loan-type-loan-box-container"
        );
        if (!container) return;

        const order = [
          "loan-type-loan-box-PROPERTY_REDIRECT", 
          "loan-type-loan-box-COMMERCIAL_PROPERTY",
          "loan-type-loan-box-SMSF_REDIRECT",
          "loan-type-loan-box-REVERSE_MORTGAGE_REDIRECT",
          "loan-type-loan-box-CAR_LOAN",
          "loan-type-loan-box-EQUIPMENT_LOAN",
          "loan-type-loan-box-PERSONAL_LOAN",
          "loan-type-loan-box-BUSINESS_LOAN",
        ];
        order.forEach((id) => {
          const el = document.getElementById(id);
          if (el) container.appendChild(el);
        });
        container.style.display = "grid";
        container.style.gridAutoFlow = "column";
        container.style.gridTemplateRows = "repeat(4, auto)";
        container.style.columnGap = "3rem";
        container.style.rowGap = "2rem";
        container.style.justifyContent = "center";
      };

      waitForAllCards();
      const observeBackButtons = () => {
        const backButtonIds = [
          "loan-amount-back-button",
          "loan-term-business-back-button",
          "loan-term-non-business-back-button",
          "loan-usage-back-button"
        ];

        const observer = new MutationObserver(() => {
          backButtonIds.forEach((id) => {
            const btn = document.getElementById(id);
            if (btn && !btn.dataset.listenerAttached) {
              btn.addEventListener("click", () => {
                setTimeout(waitForAllCards, 100); // Wait a bit to let UI render
              });
              btn.dataset.listenerAttached = "true"; // Prevent duplicate listeners
            }
          });
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      };

      observeBackButtons(); 
    };

    script.onerror = () =>
      console.error("Failed to load LoanOptions widget script");
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
      document.head.removeChild(css);
    };
  }, []);

  return <div id="repaymentWidget" />;
}
 